// @flow
import { FormBuilderContext } from 'pages/Contexts/FormBuilderContext'
import React from 'react'
import Radio from 'ui/Radio'
import Text from 'ui/Text'
import TextArea from 'ui/TextArea'
import { ZentakeContext } from 'utils/ZentakeContext'

import { CalculationComponent } from '@/components/CalculationComponent'

import type { Question } from '../../../types/question'

type Props = {
  questionId: string,
}

function hasNumberValue(obj: { number_value: ?number }) {
  return obj.number_value != null
}

function BuilderCalculationEditProps({ questionId }: Props): React$Node {
  const { teamDetails } = React.useContext(ZentakeContext)

  const { getQuestion, setQuestion, setQuestions, orderAllQuestions } =
    React.useContext(FormBuilderContext)

  const question = getQuestion(questionId)

  const onChangeCalculationValueType = React.useCallback(
    (valueType) => {
      setQuestion(questionId, {
        ...question,
        calculation_value_type: valueType,
      })
    },
    [question, questionId, setQuestion]
  )

  const onChangeCalculationFormula = React.useCallback(
    (formula) => {
      setQuestions((old) => ({
        ...old,
        [questionId]: {
          ...old[questionId],
          hasChanged: true,
          formula,
        },
      }))
    },
    [questionId, setQuestions]
  )

  const questions: Question[] = React.useMemo(() => {
    return orderAllQuestions().filter((question) => {
      if (question.id !== questionId) {
        return true
      }

      return (
        question.assign_values &&
        (question.question_choices.some(hasNumberValue) ||
          question.question_columns.some(hasNumberValue))
      )
    })
  }, [orderAllQuestions, questionId])

  return (
    <div>
      <Text.QuestionTitle>Type</Text.QuestionTitle>
      {teamDetails?.calculation_component ? (
        <>
          <Radio
            checked={question?.calculation_value_type === 'number'}
            label="Number"
            onChange={() => onChangeCalculationValueType('number')}
          />
          <Radio
            checked={question?.calculation_value_type === 'percentage'}
            label="Percentage"
            onChange={() => onChangeCalculationValueType('percentage')}
          />
          <Radio
            checked={question?.calculation_value_type === 'currency'}
            label="Currency"
            onChange={() => onChangeCalculationValueType('currency')}
          />
          <CalculationComponent
            initialValues={question.formula || ''}
            key={question.id}
            onFormulaChange={onChangeCalculationFormula}
            questions={questions}
          />
        </>
      ) : (
        <TextArea
          disabled
          placeholder={
            'Need calculations on form?\nContact Support.\nThank you'
          }
          rows={5}
        />
      )}
    </div>
  )
}

export default BuilderCalculationEditProps
